import React from "react";
import ItemAddTabs from "./ItemAddTabs";
import ItemLibrary from "./ItemLibrary";

export default function StepItems({ cfg, set, b, pi = 0, setPi }) {
  const p = cfg.periods[pi] || cfg.periods[0];
  return (
    <div className="space-y-4" data-testid="step-items">
      <ItemAddTabs cfg={cfg} set={set} b={b} />
      {cfg.periods.length > 1 && (
        <div className="flex gap-2 overflow-x-auto pb-1" data-testid="b-period-chips">
          {cfg.periods.map((pp, i) => (
            <button key={i} onClick={() => setPi(i)} className={`shrink-0 text-xs font-bold rounded-full px-3 py-2 border-2 ${pi === i ? "bg-thali-green text-white border-thali-green" : "bg-white border-thali-turmeric/30"}`}
              data-testid={`b-period-chip-${i}`}>{pp.name || `#${i + 1}`} · {pp.effective_from}</button>
          ))}
        </div>
      )}
      <div className="text-xs text-thali-ink/60" data-testid="b-editing-period">✏️ {b("editing_period")}: <b>{p.name}</b> ({p.effective_from}{p.effective_to ? ` → ${p.effective_to}` : " →"})</div>
      <ItemLibrary key={pi} cfg={cfg} set={set} b={b} pi={pi} />
    </div>
  );
}
